<template>
  <div class="comp-container">
    <gamblePopComp boxType="title" :show="true" @close="close">
      <div class="table">
        <div class="table-title">
          <div class="col-item red-black-text">
            {{ getDict(200) /*兑换道具*/ }}
          </div>
          <div class="col-item red-black-text">
            {{ getDict(201) /*消耗逐梦券*/ }}
          </div>
          <div class="col-item red-black-text">{{ getDict(202) /*时间*/ }}</div>
        </div>
        <div class="table-body" ref="logList" @scroll="onScrollList">
          <div
            class="row"
            v-for="(log, index) in logList"
            :key="index + '-' + log.ts"
          >
            <div class="col-item">
              <autoTitle textAlign="center" :title="log.name" />
            </div>
            <div class="col-item">{{ log.gold }}</div>
            <div class="col-item">
              {{ (log.ts * 1000) | formatDate("YYYY-MM-DD") }}
            </div>
          </div>
        </div>
      </div>
    </gamblePopComp>
  </div>
</template>

<script>
import { getDict, axios, webSocket } from "../../../../common";
import { mapState, mapGetters } from "vuex";
import gamblePopComp from "./../gamble-pop-comp";
import AutoTitle from "../../../../components/autoTitle";

export default {
  name: "exChangeLog",
  props: {},
  data() {
    return {
      logList: [
        // ...Array(10).fill({}).map((item,index)=>({
        //   name:index+'g',
        //   gold:index % 6 * 500,
        //   ts:1615190030,
        // }))
      ],

      pageLimit: 20,
      devReplyTime: 0,
      loading: false,
      nextCursor: 0,

      listStatus: {
        height: 0,
        boxHeight: 0,
        top: 0,
      },
    };
  },
  computed: {
    ...mapState(["userData"]),
  },
  watch: {
    logList() {
      this.$nextTick(() => {
        this.resetListStatus(true);
      });
    },
  },
  methods: {
    getDict,
    close() {
      this.$emit("close");
    },
    onScrollList() {
      this.resetListStatus();
      if (
        this.listStatus.top + 3 * this.listStatus.boxHeight >
        this.listStatus.height
      ) {
        // this.getLogList();
      }
    },
    resetListStatus(widthChange = false) {
      if (!this.$refs.logList) {
        return;
      }
      if (widthChange) {
        this.listStatus.boxHeight = this.$refs.logList.clientHeight;
        this.listStatus.height = this.$refs.logList.scrollHeight;
      }
      this.listStatus.top = this.$refs.logList.scrollTop;
    },

    async getLogList() {
      if (this.nextCursor == -1 || this.loading) {
        return;
      }
      let pageSize = this.pageLimit;
      //调试用
      if (this.devReplyTime) {
        pageSize = Math.ceil(pageSize / this.devReplyTime);
      }
      this.loading = true;
      let res = await serverApi.get("exchange_log", {
        cursor: this.nextCursor,
        limit: pageSize,
      });
      this.loading = false;
      if (res.code == 200) {
        if (res.data.data) {
          let addList = res.data.data;
          this.nextCursor = res.data.next_cursor;

          //调试用
          if (this.devReplyTime) {
            let list1 = [];
            for (let item of addList) {
              for (let index = 0; index < this.devReplyTime; index++) {
                list1.push({
                  ...item,
                });
              }
            }
            addList = list1;
          }
          this.logList = this.logList.concat(addList);
        }
      } else {
        this.nextCursor = -1;
      }
    },
  },
  components: {
    gamblePopComp,
    AutoTitle,
  },
  mounted() {
    this.$nextTick(() => {
      this.resetListStatus(true);
    });

    this.$busOn("setRemUnit", () => {
      //$busOn
      this.resetListStatus(true);
    });
  },
  created() {
    this.getLogList();
  },
};
</script>

<style lang="scss" scoped>
.red-black-text {
  position: relative;
  background-image: -webkit-linear-gradient(-104deg, #5c1413, #e04445);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.comp-container {
  .table {
    height: 2.41rem;
    // width: 7.1rem;
    display: flex;
    flex-direction: column;
    $line-height: 0.5rem;
    $border-color: rgba(255, 255, 255, 0.8);
    border: 0.01rem solid $border-color;
    .col-item {
      display: inline-block;
      height: $line-height;
      line-height: $line-height;
      width: 33.3%;
      text-align: center;
    }
    .table-title {
      display: flex;
      flex-shrink: 0;
      // font-size: 0.26rem;
      font-size: 0.23rem;
      font-weight: 600;
      color: #292829;
      // background-color: $border-color;
      background-image: url(./imgs/exchange-pop-title.png);
      background-size: 100% 100%;
      height: $line-height;
    }
    .table-body {
      flex: 1;
      overflow-y: auto;
      overflow-x: hidden;
      font-size: 0.22rem;
      color: #bababa;

      .row {
        display: flex;
      }
    }
  }
}
</style>
